import React from 'react';
import { bulletListSelector } from '@atlaskit/adf-schema';
import { getListIndentLevel } from '../utils/lists';
export default function BulletList(props) {
  return /*#__PURE__*/React.createElement("ul", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: bulletListSelector.substr(1),
    "data-local-id": props.localId,
    "data-indent-level": props.path ? getListIndentLevel(props.path) : 1
  }, props.children);
}